const PAGE_ID_MAPPING = {
  SECONDARY: "710",
  REAGREEMENT: "709",
};

const ITEM_ANALYTIC_ID_MAPPING_OLD_AGREEMENT = {
  //Old agreement items
  CUST_MAR: {
    checkboxId: "7202",
    labelId: "7200",
    detailsId: "7203",
  },
  AGREE_ALL: {
    checkboxId: "7030",
    labelId: "7040",
    agreeValue: "Agree to all",
  },
  AGREE_TERM_AND_CONDITION: {
    checkboxId: "7031",
    labelId: "7041",
    detailsId: "7051",
  },
  AGREE_SPECIAL_TERM: {
    checkboxId: "7032",
    labelId: "7042",
    detailsId: "7052",
  },
  AGREE_PRIVACY_NOTICE: {
    checkboxId: "7033",
    labelId: "7043",
    detailsId: "7053",
  },
  PI: {
    checkboxId: "7036",
    labelId: "7046",
    detailsId: "7056",
  },
  AGREE_REGISTER_MY_PHONE: {
    checkboxId: "7084",
    labelId: "7085",
    detailsId: "7086",
  },
  CUSTOMIZATION_SERVICE_PI: {
    checkboxId: "7091",
    labelId: "7092",
    detailsId: "7093",
  },
  CUSTOMIZATION_SERVICE_SENSITIVE_PI: {
    checkboxId: "7094",
    labelId: "7095",
    detailsId: "7096",
  },
  SHARING_FEATURES_PI: {
    checkboxId: "7097",
    labelId: "7098",
    detailsId: "7099",
  },
  SHARING_FEATURES_SENSITIVE_PI: {
    checkboxId: "7100",
    labelId: "7101",
    detailsId: "7102",
  },
  SHARING_PI: {
    checkboxId: "7197",
    labelId: "7198",
    detailsId: "7199",
  },
  CROSS_PI: {
    checkboxId: "7205",
    labelId: "7206",
    detailsId: "7207",
  },
  MKT: {
    checkboxId: "7126",
    detailsId: "7127",
    labelId: "7126",
    agreeValue: "Marketing information",
  }
};

const ITEM_ANALYTIC_ID_MAPPING_NEW_AGREEMENT = {
  //New agreement items
  AGREE_ALL: {
    checkboxId: "7030",
    labelId: "7040",
    agreeValue: "Agree to all",
  },
  TC: {
    checkboxId: "7031",
    labelId: "7041",
    detailsId: "7051",
    agreeValue: "T&C and Special terms",
  },
  CSC: {
    checkboxId: "7084",
    detailsId: "7086",
    agreeValue: "Register phone number",
  },
  PN: {
    checkboxId: "7036",
    agreeValue: "Privacy policy",
  },
  TERM_AND_CONDITION: {
    checkboxId: "7031",
  },
  SPECIAL_TERM: {
    checkboxId: "7032",
  },
  NOFI: {
    checkboxId: "70317",
    agreeValue: "Notice of Financial Incentives",
  },
  CZSVC: {
    checkboxId: "7034",
    detailsId: "7054",
    agreeValue: "Customization service",
  },
  MKT: {
    checkboxId: "7035",
    detailsId: "7055",
    agreeValue: "Personal information for ads Marketing information",
  },
  CZADV: {
    checkboxId: "70310",
    detailsId: "70311",
    agreeValue: "Improve personalized advertising",
  },
  GEO: {
    checkboxId: "70312",
    detailsId: "70313",
    agreeValue: "Use precise location data",
  },
  MKTPN: {
    checkboxId: "70314",
    detailsId: "70315",
  },
  "3RD_MKTPN": {
    checkboxId: "70320",
    detailsId: "70321",
    agreeValue: "Personal information for third parties",
  },
  "3RD_MKT": {
    checkboxId: "70322",
    detailsId: "70323",
    agreeValue: "Get marketing information from affiliates",
  },
  TC_REWARDS: {
    checkboxId: "7121",
    detailsId: "7122",
    agreeValue: "Turn on Samsung Rewards",
  },
};

const getAnalyticIdsNewAgreement = (itemId, screenId, style) => {
  const EXPECTED_ITEM_ANALYTIC_ID_MAPPING = {...ITEM_ANALYTIC_ID_MAPPING_NEW_AGREEMENT};
  switch (style) {
    case "setk":
      EXPECTED_ITEM_ANALYTIC_ID_MAPPING["MKTPN"] = {
        checkboxId: "7076",
        detailsId: "7078",
      };
      break;
    case "latam":
      EXPECTED_ITEM_ANALYTIC_ID_MAPPING["PN"] = {
        checkboxId: "7081",
        agreeValue: "Privacy policy",
      };
      break;
    default:
      break;
  }
  return {
    pageId: screenId,
    ...EXPECTED_ITEM_ANALYTIC_ID_MAPPING[itemId],
  };
};

const getAnalyticIdsOldAgreement = (itemId, screenId) => {
  return {
    pageId: screenId,
    ...ITEM_ANALYTIC_ID_MAPPING_OLD_AGREEMENT[itemId],
  };
};

const chinaRegions = ["CHN"];

const HTTP_STATUS_ENUM = {
  OK: 200,
  NOT_FOUND: 404,
  NO_CONTENT: 204,
  UN_AUTHORIZED: 401,
};

const BUTTON_ANALYTIC_ID_MAPPING_OLD_AGREEMENT = {
  "AGREE": "7106",
  "CONTINUE": "7196",
  "CANCEL": "7118",
  "SKIP": "7105",
  "MORE": "7062",
};

const  BUTTON_ANALYTIC_ID_MAPPING_NEW_AGREEMENT = {
  "AGREE_US": "7106",
  "AGREE_EU": "7196",
  "CONTINUE_EU": "7196",
  "CONTINUE_US": "7106",
  "CANCEL": "70319",
  "SKIP": "7105",
  "MORE": "7062",
}

const DEFAULT_APPLICATION_REGION = "XEX";

export {
  PAGE_ID_MAPPING,
  getAnalyticIdsNewAgreement,
  getAnalyticIdsOldAgreement,
  HTTP_STATUS_ENUM,
  chinaRegions,
  BUTTON_ANALYTIC_ID_MAPPING_OLD_AGREEMENT,
  BUTTON_ANALYTIC_ID_MAPPING_NEW_AGREEMENT,
  ITEM_ANALYTIC_ID_MAPPING_NEW_AGREEMENT,
  ITEM_ANALYTIC_ID_MAPPING_OLD_AGREEMENT,
  DEFAULT_APPLICATION_REGION
};
